import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/PageTitle/PageTitle";
import Button from "../../components/Button/Button";
import { Icon } from "@iconify/react";
import Tabs from "@mui/lab/TabList";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import Password from "./components/Password";
import Incentives from "./components/Incentives";
// import RolesandPermission from "./components/RolesandPermission";
// import Apikeys from "./components/Apikeys";
import { Grid, Tab } from "@mui/material";
import Modal from "../../components/Modal";
import InputGroup from "../../components/FormComponent/InputGroup";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import { useState } from "react";
import styles from "./settings.module.css";

// --| Dummy Data
import { Roles } from "../../utils/DropDown";

const Settings = () => {
  const [createapimodal, setCreateApiModal] = useState(false);
  const [createdapimodal, setCreatedApiModal] = useState(false);

  const handleCreatedApiModal = () => {
    setCreatedApiModal(!createdapimodal);
  };
  const handleCreateApiModal = () => {
    setCreateApiModal(!createapimodal);
  };

  const [value, setValue] = useState("1");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Layout children={
      <>
        <PageTitle
          title="Settings"
          subtitle="You can make changes to your organisation’s account."
        />
        <TabContext value={value}>
          <div className="tablist-container">
            <Tabs indicatorColor="none" className="overide-tablist" onChange={handleChange} aria-label="">
              <Tab label="Password" value="1" />
              <Tab label="Incentives" value="2" />
              {/* <Tab label="Roles and Permissions" value="3" />
              <Tab label="Api Keys" value="4" /> */}
            </Tabs>
          </div>
          <TabPanel value="1" className="tabpanel-overide">
            <Password />
          </TabPanel>
          <TabPanel value="2" className="tabpanel-overide">
            <Incentives />
          </TabPanel>
          {/* <TabPanel value="3" className="tabpanel-overide"><RolesandPermission /></TabPanel>
          <TabPanel value="4" className="tabpanel-overide"><Apikeys /></TabPanel> */}
        </TabContext>
        {/* Create API Modal */}
        <Modal
          title="Create API Keys"
          subtitle={
            <div>Here you can save and embedded the code for email templates.
            </div>}
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Title"
                    margin="normal"
                    placeHolder="Api title."
                    inputType="text"
                  />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <SelectGroup label="Assign To" children={
                    <select>
                      <option value="">--- Select School ---</option>
                      {Roles?.map((label) => {
                        return (
                          <option key={label.key}>{label?.text}</option>
                        );
                      })}
                    </select>
                  }
                  />
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button onClick={handleCreatedApiModal} variant="primary" buttonSize="full" color="btndefault" buttonName="Create API keys" />
            </>
          }
          isopen={createapimodal}
          closeModal={handleCreateApiModal}
        />
        {/* Created API Modal */}
        <Modal
          title="API key created"
          modalContent={
            <>
              <Grid container spacing={2} className={`${styles.copyinput}`}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Title"
                    margin="normal"
                    placeHolder="Api created"
                    inputType="text"
                  />
                  <div className={`${styles.copyicon}`}>
                    <Icon icon="bxs:copy" width="16" height="16" />
                  </div>
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <Button onClick={handleCreateApiModal} variant="primary" buttonSize="full" color="btndefault" buttonName="Create API keys" />
            </>
          }
          isopen={createdapimodal}
          closeModal={handleCreatedApiModal}
        />
      </>
    }
    />
  );
};

export default Settings;
